import React from "react"
import clsx from "clsx"

import { LazyImage } from "components"
import { getComboItemFoodDetail } from "utils"
import classes from "./ComboModalCard.module.scss"

const ComboModalCard = props => {
  const {
    comboSetItem,
    comboSetId,
    comboSetIndex,
    comboSetBranchId,
    selectedComboItems,
    setSelectedComboItems
  } = props

  const handleSelect = () => {
    setSelectedComboItems(prev => {
      const array = [...prev]

      array[comboSetIndex] = comboItemFoodDetail

      return array
    })
  }

  const comboItemFoodDetail =
    getComboItemFoodDetail(
      comboSetItem,
      comboSetId,
      comboSetBranchId
    )

  if (comboItemFoodDetail === null) return null

  const outOfStock =
    comboItemFoodDetail.isAvailable
      ?
      comboItemFoodDetail.outOfStock ||
      (
        comboItemFoodDetail.stockManagement &&
        comboItemFoodDetail.availableQuantity <= 0
      )
      :
      true

  const isSelected =
    selectedComboItems.some(selectedComboItem =>
      selectedComboItem?.comboSetItemId === comboSetItem._id
    )

  return (
    <div className={classes["container"]}>
      <div
        onClick={handleSelect}
        className={clsx(
          classes["wrapper"],
          outOfStock && classes["disabled"],
          isSelected && classes["isActive"]
        )}
      >
        <LazyImage
          src={comboItemFoodDetail.foodImageCover}
          className={classes["image"]}
          imageWidth={100}
          quality={60}
        />
        <div
          disabled={outOfStock}
          className={classes["details"]}
        >
          <div className={classes["code"]}>
            کد: {comboItemFoodDetail.foodCode}
          </div>
          <div className={classes["name"]}>
            {comboItemFoodDetail.foodName}
          </div>
          <div
            className={classes["optionName"]}
          >
            {!comboItemFoodDetail.isSimple ?
              `(${comboItemFoodDetail.optionName})` : ""
            }
          </div>
        </div>
        {outOfStock ?
          <div className={classes["outOfStock"]}>
            ناموجود
          </div> :
          <div className={classes["quantity"]}>
            x {comboItemFoodDetail.quantity}
          </div>
        }
      </div>
    </div>
  )
}

export default ComboModalCard
